function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.4 11l4.2-4.2c.4-.4.4-1 0-1.4s-1-.4-1.4 0L11 9.6 6.8 5.3c-.4-.3-1.1-.3-1.5 0-.3.4-.3 1.1 0 1.5L9.6 11l-4.2 4.2c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l4.2-4.2 4.2 4.2c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L12.4 11z"
});
function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22"
  }, props), _ref);
}
export default SvgCross;